/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon, SelectorIcon } from '@heroicons/react/solid'
import {useTranslation} from "react-i18next";
const publishingOptions = [
    { title: 'en', current: true },
    { title: 'ar', current: false },
    { title: 'fr', current: false },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function LanguageSwitcher() {
    const {i18n} = useTranslation();
    const [selected, setSelected] = useState(publishingOptions[2].title)

    return (
        <Listbox value={selected} onChange={async (value) => {
            setSelected(value);
            await i18n.changeLanguage(value);

        }}>
            {({ open }) => (
                <>
                    <Listbox.Label className="sr-only">Change published status</Listbox.Label>
                    <div className="relative">
                        <div className="inline-flex shadow-sm rounded-md divide-x divide-indigo-600">
                            <div className="relative z-0 inline-flex shadow-sm rounded-md divide-x divide-indigo-600">
                                <div className="relative inline-flex items-center bg-indigo-500 py-1 pl-2 pr-4 border border-transparent rounded-l-md shadow-sm text-white">
                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                    <p className="ml-2.5 text-sm font-medium">{selected.toUpperCase()}</p>
                                </div>
                                <Listbox.Button className="relative inline-flex items-center bg-indigo-500 p-2 rounded-l-none rounded-r-md text-sm font-medium text-white hover:bg-indigo-600 focus:outline-none focus:z-10 focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500">
                                    <span className="sr-only">Change published status</span>
                                    <ChevronDownIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                </Listbox.Button>
                            </div>
                        </div>

                        <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Listbox.Options
                                static
                                className="origin-top-right absolute z-10 right-0 mt-2 w-48 rounded-md shadow-lg overflow-hidden bg-white divide-y divide-gray-200 ring-1 ring-black ring-opacity-5 focus:outline-none"
                            >
                                {publishingOptions.map((option) => (
                                    <Listbox.Option
                                        key={option.title}
                                        className={({ active }) =>
                                            classNames(
                                                active ? 'text-white bg-indigo-500' : 'text-gray-900',
                                                'cursor-default select-none relative p-4 text-sm'
                                            )
                                        }
                                        value={option.title}
                                    >
                                        {({ selected, active }) => (
                                            <div className="flex flex-col">
                                                <div className="flex justify-between">
                                                    <p className={selected ? 'font-semibold' : 'font-normal'}>{option.title.toUpperCase()}</p>
                                                    {selected ? (
                                                        <span className={active ? 'text-white' : 'text-indigo-500'}>
                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                            </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </Transition>
                    </div>
                </>
            )}
        </Listbox>
    )
}


export function LanguageDropDown() {
    const {i18n} = useTranslation();
    const [selected, setSelected] = useState(publishingOptions[2].title)

    return (
        <Listbox value={selected} onChange={async (value) => {
            setSelected(value);
            await i18n.changeLanguage(value);

        }}>
            {({ open }) => (
                <>
                    <div className="mt-1 relative z-10">
                        <Listbox.Button className="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                            <span className="block truncate">{selected.toUpperCase()}</span>
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <SelectorIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </span>
                        </Listbox.Button>

                        <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Listbox.Options
                                static
                                className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                            >
                                {publishingOptions.map((person) => (
                                    <Listbox.Option
                                        key={person.title}
                                        className={({ active }) =>
                                            classNames(
                                                active ? 'text-white bg-indigo-600' : 'text-gray-900',
                                                'cursor-default select-none relative py-2 pl-8 pr-4'
                                            )
                                        }
                                        value={person.title}
                                    >
                                        {({ selected, active }) => (
                                            <>
                        <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                          {person.title.toUpperCase()}
                        </span>

                                                {selected ? (
                                                    <span
                                                        className={classNames(
                                                            active ? 'text-white' : 'text-indigo-600',
                                                            'absolute inset-y-0 left-0 flex items-center pl-1.5'
                                                        )}
                                                    >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </Transition>
                    </div>
                </>
            )}
        </Listbox>
    )
}

